/**
 * EmailJS Configuration
 * 
 * Configuration for EmailJS service
 * You'll need to replace these with your actual EmailJS credentials
 */

export const emailjsConfig = {
  // Your EmailJS Public Key (found in EmailJS dashboard)
  publicKey: 'VRuEFKTZZn_9DGtok',
  
  // Your EmailJS Service ID (found in EmailJS dashboard)
  serviceId: 'service_jbcqv3n',
  
  // Your EmailJS Template IDs
  templates: {
    contact: 'template_x023qls', // For contact form emails
    review: 'template_3apbr9q' // For review confirmation emails
  },
  
  // Your business email (where emails will be sent)
  businessEmail: 'hi@rcroof.co'
};

export default emailjsConfig;
